<template>
  <div>
    <DialogContainer v-model="dialogObj">
      <template v-slot:dialogSlot>
        <div class="business-body custom-form">
          <div class="order-detail-box">
            <div class="label-val">
              <div class="value-1">{{ detail.companyName }}</div>
            </div>
            <div class="label-val">
              <div class="label-1">{{userType === 3?'司机姓名':'负责人姓名'}}</div>
              <div class="value-1">{{ detail.username || detail.adminUsername  }}</div>
            </div>
            <div class="label-val">
              <div class="label-1">{{userType === 3?'司机':'负责人'}}联系电话</div>
              <div class="value-1">{{ detail.phone || detail.adminPhone }}</div>
            </div>
            <div class="label-val">
              <div class="label-1">钱包余额</div>
              <div class="value-1">￥{{ detail.balance }}</div>
            </div>
          </div>
          <div class="tab-box">
            <custom-tab-box :tab-data="tabData" :selectTab="searchForm.range" @change="handleChange"></custom-tab-box>
          </div>
          <div class="search-form-box">
            <el-row :gutter="30">
              <el-form inline>
                <el-col :span="6">
                  <el-form-item label="交易时间:">
                    <custom-date-range
                      :start-date="searchForm.startTime"
                      :end-date="searchForm.endTime"
                      @update:startDate="
                        (val) => (searchForm.startTime = val)
                      "
                      @update:endDate="
                        (val) => (searchForm.endTime = val)
                      "></custom-date-range>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="交易类型:" prop="recordType">
                    <el-select
                      style="width: 100%"
                      v-model="searchForm.recordType"
                      filterable
                      clearable
                      placeholder="请选择">
                      <el-option
                        v-for="item in $dict.recordTypeOptions"
                        :key="item.dictCode"
                        :label="item.dictLabel"
                        :value="item.dictCode"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="">
                    <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                    <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
          </div>
          <div class="custom-table-box1">
            <el-table
              :loading="tableOptions.loading"
              :data="tableData"
              :row-style="showRow"
              stripe
              :header-cell-style="tableHeaderColor"
              style="width: 100%">
              <el-table-column prop="recordTime" label="交易时间"></el-table-column>
              <el-table-column prop="income" label="收支类型">
                <template slot-scope="scope">
                  {{
                  scope.row.income ? "收入" : "支出"
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="recordTypeName" label="交易类型"></el-table-column>
              <el-table-column prop="remark" width="300px" label="内容说明">
                <template slot-scope="scope">
                  <span class="color526bec" style="cursor: pointer" v-if="scope.row.recordType !== 11" @click="turnToOrderDetail(scope.row)">{{ scope.row.remark }}</span>
                  <span v-else>{{scope.row.remark}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="交易金额">
                <template slot-scope="scope">
                  <span class="color52C41A">{{ scope.row.income ? "+" : "-"}}{{ scope.row.amount }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="nowBalance" label="交易后余额">
                <template slot-scope="scope">￥{{ scope.row.nowBalance }}</template>
              </el-table-column>
              <el-table-column prop="attachments" label="付款凭证">
                <template slot-scope="scope">
                  <span class="color1269FF" v-if="scope.row.attachments && scope.row.attachments.length > 0">
                    <el-image
                      v-for="(item, index) in scope.row.attachments"
                      :key="index"
                      :src="getFileUrl(item.fileId)"
                      :preview-src-list="[getFileUrl(item.fileId)]"
                      class="info-img"></el-image>
                  </span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-box">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableOptions.currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="tableOptions.pageSize"
              background
              :total="tableOptions.total" />
          </div>
        </div>
      </template>
    </DialogContainer>
    <image-list ref="imageList"></image-list>
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { getSupplierWalletPage, getAgentWalletPage, getDriverWalletPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import imageList from "./imageList.vue";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import { getFileUrl } from "@/utils/tool";
import CustomDateRange from "@/components/CustomDateRange.vue";
import detail from "@/views/OrderManagement/detail.vue"
export default {
  name: "Detail",
  mixins: [tableMixin],
  components: {
    CustomTabBox,
    imageList,
    DialogContainer,
    CustomDateRange,
    detail,
  },
  data() {
    return {
      getTableMethod: "",
      userType: 1, // 1代理商钱包 2服务商钱包 3司机钱包
      tabData: [
        {
          label: 0,
          value: "全部",
        },
        {
          label: 1,
          value: "收入",
        },
        {
          label: 2,
          value: "支出",
        },
      ],
      isImmediatelyGetData: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "80%",
        show: false,
        title: "钱包明细",
        closeOnClickModal: false,
        confirmFn: null,
        beforeClose: (v) => {
          this.selectTab = 1;
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      searchForm: {
        range: 0,
        startTime: "",
        endTime: "",
        recordType: "",
        targetId: "",
      },
      detail: {},
    };
  },
  mounted() {},
  methods: {
    getFileUrl,
    turnToOrderDetail(row) {
      let item = Object.assign({}, {orderId: row.sourceId}, row);
      this.$refs.detail.init(item);
    },
    checkDetail(list) {
      this.$refs.imageList.init(list);
    },
    handleReset() {
      this.searchForm.startTime = "";
      this.searchForm.endTime = "";
      this.searchForm.recordType = "";
      this.tableOptions.currentPage = 1;
      this.getTableData();
    },
    init(userType, row) {
      this.searchForm.range = 0
      this.userType = userType
      switch (userType) {
        case 1:
          this.getTableMethod = getAgentWalletPage
              break;
        case 2:
            this.getTableMethod = getSupplierWalletPage
          break;
        case 3:
              this.getTableMethod = getDriverWalletPage
          break;
        default:
          this.getTableMethod = getAgentWalletPage
          break;
      }
      this.searchForm.targetId = row.userId || row.companyId;
      this.detail = Object.assign({}, row);
      this.getTableData();
      this.dialogObj.show = true;
    },
    handleChange(val) {
      // // console.log("val", val);
      this.searchForm.range = val;
      // if (val === 1) {
      //   this.searchForm.income = "";
      // } else if (val === 2) {
      //   this.searchForm.income = true;
      // } else if (val === 3) {
      //   this.searchForm.income = false;
      // }
      this.handleReset();
    },
    handleSizeChange(val) {
      this.tableOptions.currentPage = 1;
      this.tableOptions.pageSize = val;
    },
    handleCurrentChange(val) {
      this.tableOptions.currentPage = val;
      this.getTableData();
    },
    tableHeaderColor() {
      return {
        background: "#F0F5FF",
        color: "#000000",
        fontFamily: "pm",
        fontSize: "0.14rem",
      };
    },
    showRow({ row, rowIndex }) {
      let styleJson = {};
      if (rowIndex % 2 === 0) {
        styleJson = {
          height: "46px",
          background: "#fff",
        };
      } else {
        styleJson = {
          height: "46px",
          background: "rgba(240,245,255,0.4)",
          border: "none",
        };
      }
      // 返回对象
      return styleJson;
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  .search-form-box {
  }
  .order-detail-box {
    display: flex;
    width: 100%;
    height: 0.8rem;
    background: #f7fbff;
    padding: 0.1rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .label-val {
      width: 33.3%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .label-1 {
        color: #8c8c8c;
        font-size: 0.12rem;
        padding-bottom: 0.06rem;
      }
      .value-1 {
        color: #434343;
      }
    }
    .label-val:after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.01rem;
      height: 0.26rem;
      background: #dce5f5;
    }
    .label-val:nth-last-of-type(1):after {
      display: none;
    }
  }
  .tab-box {
    display: flex;
    justify-content: center;
    position: sticky;
    top: -0.2rem;
    z-index: 10;
    background-color: #ffffff;
    padding: 0.1rem 0;
  }
  .custom-table-box1 {
    box-sizing: border-box;
    background: #f7f8fb;
    //margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    border-radius: 0.08rem;
    padding: 0.1rem;
    ::v-deep .el-table__header-wrapper {
      position: relative;
    }
    ::v-deep .el-table .cell {
      line-height: 0.3rem;
    }
  }
  .pagination-box {
    position: sticky;
    bottom: -0.22rem;
    background-color: #ffffff;
    padding: 0.2rem 0;
  }
  .info-img{
    width: 0.6rem;
    height:0.6rem;
  }
}
</style>
